import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { ApiError, tinctApi } from '../../api';

export type DeleteCampaignParams = {
  campaignId: string;
};

export const deleteCampaign = async (
  params: DeleteCampaignParams,
): Promise<void> => {
  return await tinctApi.campaigns.deleteCampaign(params.campaignId);
};

export const useDeleteCampaign = (
  options?: Omit<
    UseMutationOptions<void, ApiError, DeleteCampaignParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCampaign,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ['campaigns'],
      });
      queryClient.removeQueries({
        queryKey: ['campaign', args[1].campaignId],
      });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
